@import 'styles/mixins';
@import 'styles/blaze/mixins';

.overlay {
  @include blur(2.5px);
  background: var(--overlay);
  inset: 0;
  position: fixed;
  z-index: z-index(greaterThanAntd);

  &.withoutBlur {
    backdrop-filter: none;
  }

  &.withoutOpacity {
    background: none;
  }

  + .overlay {
    z-index: z-index(heaven);
  }
}

.content {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: z-index(heaven);
  border-radius: 15px 15px 0 0;
  background: transparent;
  max-height: 100%;
  &:focus-visible {
    outline: none;
  }

  &.fullHeight {
    height: 100%;

    .innerContent {
      height: 100%;
    }

    .container {
      height: 100%;
    }
  }

  &.heightDynamic {
    height: unset !important;
  }

  &.fixedBottom {
    bottom: 0 !important;
  }

  &.disableAnimation {
    transition: none !important;
    animation: none !important;
  }
}

.innerContent {
  @include blur;
  border-radius: 15px 15px 0 0;
  box-shadow: 0 8px 37px 0 var(--dark-10);
  overflow: hidden;
  background: var(--light-100);

  &.withShadow {
    box-shadow: 0 8px 47px 0 var(--dark-40);
  }

  &.snappedTop {
    border-radius: 0;

    &.withShadow .top {
      box-shadow: 0.5px 0.5px 0 0 #fff inset, 0 6px 32px 0 rgba(0, 0, 0, 0.15);
    }
  }

  .top + .container {
    height: calc(100% - 46px); // account for the top bar
  }
}

.container {
  @include hide-scrollbar;
  padding: 15px;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
}

.top {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 5px;
  min-height: 46px;
}

.handleContainer {
  width: 100%;
  position: absolute;
  margin-top: -11px;
}

.handle {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40px;
  height: 5px;
  border-radius: 15px;
  background: var(--dark-40);
  margin-bottom: 6px;
}

.closeButton,
.backButton {
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    font-size: 16px;
    letter-spacing: 0.32px;
    line-height: 139%;
  }
}

.closeButton {
  margin-left: auto;

  button {
    margin-left: auto;
  }

  &.left {
    button {
      margin-left: initial;
      margin-right: auto;
    }

    margin-left: initial;
    margin-right: auto;
  }
}

.backButton {
  margin-right: auto;

  button {
    margin-right: auto;
  }

  &.right {
    button {
      margin-right: initial;
      margin-left: auto;
    }

    margin-right: initial;
    margin-left: auto;
  }
}
